export enum StoredDocumentTypeEnum {
  LivingWill = 1,
  DNR = 2,
  DNI = 3,
  POLST = 4,
  MOLST = 5,
  PowerOfAttorney = 6,
  FaceToFace = 7,
  Immunization = 8,
  HP = 9,
  InsuranceCard = 10,
  WoundPhoto = 11,
  LabResults = 12,
  HospitalDischargeSummary = 13,
  WrittenOrder = 14,
  HealthcareSurrogate = 15
}

export const StoredDocumentTypeOptions = [
{ id: 1, label: 'Living Will', documentCategory: 'ACD' },
{ id: 2, label: 'DNR (Do Not Resuscitate)', documentCategory: 'ACD' },
{ id: 3, label: 'DNI (Do Not Incubate)', documentCategory: 'ACD' },
{ id: 4, label: 'POLST (Physician Orders for List-Sustaining Treatment)', documentCategory: 'ACD' },
{ id: 5, label: 'MOLST (Medical Orders for List-Sustaining Treatment)', documentCategory: 'ACD' },
{ id: 6, label: 'Medical Power Of Attorney', documentCategory: 'ACD' },
{ id: 7, label: 'Face-to-Face Visit', documentCategory: 'F2F' },
{ id: 8, label: 'Immunization', documentCategory: 'Immunization' },
{ id: 9, label: 'History & Physical Examination', documentCategory: 'MedicalHistory' },
{ id: 10, label: 'Insurance Card', documentCategory: 'Insurance' },
{ id: 11, label: 'Wound Photo', documentCategory: 'Wounds' },
{ id: 12, label: 'Lab Results', documentCategory: 'Wounds' },
{ id: 13, label: 'Hospital Discharge Summary', documentCategory: 'MedicalHistory' },
{ id: 14, label: 'Written Order', documentCategory: 'Orders' },
{ id: 15, label: 'Healthcare Surrogate/Decision Maker', documentCategory: 'ACD' }
];
